<template>
    <div class="container" v-title="'报名须知'">
        <Navigation-bar title="报名须知" v-scrollShadow="scrollTop"></Navigation-bar>
        <div class="container_content" v-if="pageShow">
            <Scroll
                ref="scroll"
                @scrollChange="scrollChange"
            >
                <div id="AdmissionInformation" ref="content">
                    <div class="rich_text" v-html="EnrollNotice" ref="content" v-if="EnrollNotice"></div>
                    <div class="image_list" v-if="detail.PictureFiles">
                        <img :src="item.FileUrl" v-for="(item, index) in detail.PictureFiles" :key="index" @load="load()" @click="previewImage(item.FileUrl, imageUrls)" />
                    </div>
                    <div class="file_list" v-if="detail.DocFiles">
                        <div class="file_item" v-for="(item, index) in handleDocFiles" :key="index" @click="openFile(item.url, item.name)">
                            <div class="file_icon" :class="item.className"></div>
                            <div class="file_info">
                                <div class="file_name">{{item.name}}</div>
                                <div class="file_size">{{item.size}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="down_hint" v-if="isOverflow && !isEnd">
						<img src="@images/icon/down_hint@2x.png"></img>
						<div class="text">下滑到底部<br/>点击同意</div>
					</div>
                </div>
                <div id="bottomBlank"><!--允许页面向上滚动到露出底部空白--></div>
            </Scroll>
        </div>
        <div class="bottom_operation" v-if="pageShow">
            <div class="button" @click="confirm()" v-if="!isOverflow || isEnd">我已阅读并同意</div>
            <div class="button disabled" v-else>请下滑看完点击同意</div>
        </div>
        <ImagePreview v-model="image.show" :images="image.list" :start-position="image.index" @change="image.index = $event" lazyLoad></ImagePreview>
        <YD-image src="icon/icon_保存" class="save_image" v-show="image.show" @click.native="saveImage"></YD-image>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
import 'vant/lib/image-preview/style';
import tools from '@/common/tools';
import communicate from '@/common/communicate';
import appInteraction from '@/common/appInteraction.js';
export default {
    name:"AdmissionInformation",
    components: {
        ImagePreview: ImagePreview.Component
    },
    data(){
        return {
            subLeagueId: 0,
            pageShow: false,
            scrollTop: 0,
			containerHeight: 0,
			contentHeight: 0,
			isOverflow: false,
			isEnd: false,
            detail: {},
            image:{
                list: [],
                index: 0,
                show: false
            },
        }
    },
    created(){
        let subLeagueId = +(this.$route.query.subLeagueId || 0);
        this.subLeagueId = subLeagueId;
        this.getDetail();
    },
	computed:{
		EnrollNotice(){
			return this.detail.EnrollNotice;
		},
        imageUrls(){
			if(!this.detail.PictureFiles) return [];
			return this.detail.PictureFiles.map(item=>item.FileUrl);
		},
		handleDocFiles(){
			if(!this.detail.DocFiles) return [];
			return this.detail.DocFiles.map(item=>{
				let name = item.FileName,
					url = item.FileUrl;
				let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
				if(!type){
					type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
				}
				let className = type;
				if(['docx', 'doc'].includes(type)){
					className = 'word';
				}else if(['xlsx', 'xls'].includes(type)){
					className = 'excel';
				}else if(['pptx', 'ppt'].includes(type)){
					className = 'ppt';
				}else if(['pdf'].includes(type)){
					className = 'pdf';
				}
				return {
					url,
					name,
					type,
					size: tools.formatFileSize(item.FileSize),
					className
				}
			})
		}
	},
    methods: {
		confirm(){
            this.$api.UserAgreeLeagueEnrollNotice({
				LeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    communicate.admissionInformation.$emit();
                    this.$navigation.back();
                }
            })
		},
        getDetail(){
            this.$api.GetLeagueEnrollNotice({
                LeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    this.pageShow = true;
                    this.detail = data.Notice || {};
                    this.setNoticeImages();
                    this.$nextTick(function(){
                        this.containerHeight = this.$refs.scroll.$el.offsetHeight;
                        this.load();
                    })
                }
            })
        },
        setNoticeImages(){
            this.$nextTick(function(){
                let images = [],
                    imageDom = this.$refs.content.querySelectorAll('img');
                if(imageDom.length > 0){
                    imageDom.forEach((item) => {
                        let url = item.getAttribute('src');
                        images.push(url);
                        item.onclick = ()=>{
                            this.previewImage(url, images);
                        }
                        item.onload = ()=>{
                            this.load();
                        }
                    });
                }
            });
        },
		load(){
			let height = this.$refs.content.offsetHeight;
            if(height > this.contentHeight){
                this.contentHeight = height;
                if(this.containerHeight < height){
                    this.isOverflow = true;
                }
            }
		},
		scrollChange(scrollTop){
			this.scrollTop = scrollTop;
			if(this.scrollTop >= this.contentHeight - this.containerHeight - 1){
				this.isEnd = true;
			}
		},
        previewImage(url, urls){
			if(!url) return;
			if(!urls){
				urls = [url];
			}
            let index = urls.indexOf(url);
            this.image = {
                list: urls,
                index: index,
                show: true
            };
        },
        saveImage(){
            let {
                list,
                index
            } = this.image;
            appInteraction.saveImage(list[index]);
        },
        //查看文件
        openFile(url, name){
            this.$navigation.go(`/Rules/OnlinePreview?file_url=${encodeURIComponent(url)}&name=${name}&download=1`);
        }
    }
}
</script>
<style lang="scss" scoped>
.container_content .scroll{
	height: calc(100% - 120px - var(--safe-area-inset-bottom));
}
#AdmissionInformation{
    padding: 108px 40px 60px;
    box-sizing: border-box;
	position: relative;
    .rich_text + .image_list,
    .rich_text + .file_list{
        margin-top: 16px;
    }
    .image_list{
        width: 100%;
        height: auto;
        img{
            display: block;
            width: auto;
            max-width: 100%;
            height: auto;
			border-radius: 12px;
            margin: 0 auto;
            margin-bottom: 16px;
        }
    }
    .file_list{
        width: 100%;
        height: auto;
        .file_item{
            width: 100%;
            min-height: 108px;
            padding: 16px 24px;
            box-sizing: border-box;
            background: #FAFBFA;
            border-radius: 12px;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            &:last-of-type{
                margin-bottom: 0;
            }
            .file_icon{
                width: 76px;
                height: 76px;
                background: no-repeat center / 100%;
                &.word{
                    background-image: url('~@/assets/images/icon/file_word@2x.png');
                }
                &.pdf{
                    background-image: url('~@/assets/images/icon/file_pdf@2x.png');
                }
                &.excel{
                    background-image: url('~@/assets/images/icon/file_excel@2x.png');
                }
                &.ppt{
                    background-image: url('~@/assets/images/icon/file_ppt@2x.png');
                }
            }
            .file_info{
                width: calc(100% - 76px);
                padding-left: 12px;
                box-sizing: border-box;
                .file_name{
                    width: 100%;
                    font-weight: 400;
                    font-size: 28px;
                    color: #3A3F49;
                    line-height: 44px;
                }
                .file_size{
                    font-weight: 400;
                    font-size: 24px;
                    color: #8B8C8D;
                    line-height: 30px;
                }
            }
        }
    }
    .down_hint{
		width: 100%;
        height: 88px;
		position: absolute;
		top: 0;
		left: 0;
		img{
			width: 32px;
			height: 32px;
			display: block;
			margin: 0 auto;
		}
		.text{
			margin-top: 4px;
			
			font-weight: 400;
			font-size: 20px;
			color: #1B1C1E;
			line-height: 28px;
			text-align: center;
		}
	}
}
#bottomBlank{
	height: 50px;
}
.bottom_operation{
	width: 100%;
	height: calc(120px + var(--safe-area-inset-bottom));
	padding-top: 16px;
	box-sizing: border-box;
	border-top: 1px #E0E0E0 solid;
	display: flex;
	justify-content: center;
	position: absolute;
	bottom: 0;
	left: 0;
	.button{
		width: 670px;
		height: 88px;
		background: #7AD21A;
		border-radius: 20px;
		
		font-weight: 500;
		font-size: 32px;
		color: #FFFFFF;
		line-height: 88px;
		text-align: center;
		&.disabled{
			opacity: 0.6;
		}
	}
}

.van-image-preview{
    ::v-deep .van-image-preview__index{
        font-size: 32px;
    }
}
.save_image{
    width: 96px;
    height: 96px;
    position: fixed;
    bottom: 100px;
    left: calc(50% - 48px);
    z-index: 4000;
}
</style>
<style lang="scss">
@import '@assets/scss/richText.scss';
</style>